import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme, "catalogue");

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "IX0hQ8mYbg",
        width: 201.21855592497334,
        height: 73.13,
        left: 54.93,
        top: 48.84,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "none",
        fixedRatio: false,
        rotate: 0,
        text: {
          content:
            '<p style=""><strong><span style="font-size: 48.98px;"><span style="font-family: 微软雅黑;">目录</span></span></strong></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "top",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "shape",
        id: "hSXXQw1jDy",
        width: 330.3666645756226,
        height: 88.64419170691927,
        left: 56.15,
        top: 121.97,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "none",
        fixedRatio: false,
        rotate: 0,
        text: {
          content:
            '<p style=""><span style="font-size: 22px;"><span style="font-family: 微软雅黑;">CONTENTS</span></span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "top",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "i8q5rumCkZ",
        width: 37.21,
        height: 60,
        left: 0,
        top: 0,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: left;"><span style="font-size: 1.02px;font-family: 微软雅黑;">行业</span><span style="font-size: 1.02px;font-family: 微软雅黑;">PPT</span><span style="font-size: 1.02px;font-family: 微软雅黑;">模板</span><span style="font-size: 1.02px;font-family: 微软雅黑;">http://www.1ppt.com/hangye/</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 268.38435695538055,
        top: 200.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
    ],

    background,
  };
}
